import { Pedido } from 'src/app/models/pedido';
export enum TipoUpload {
  UmArquivo = 0,
  VariosArquivos = 1
}

export enum Relatorios {
  Cliente,
  Acesso,
  OrcamentoSintetico,
  OrcamentoSinteticoPorDataCriacao,
  OrcamentoAnalitico,
  OrcamentoPorCidade,
  OrcamentoCustos,
  PedidoAnalitico,
  PedidoSintetico,
  VendaSintetico,
  VendaAnalitico,
  VendaPorCidade,
  VendaPorProduto,
  VendaCustos,
  VendaKwp,
  VendaComissao,
  VendaComissaoTimes,
  PotenciaVendida,
  TaxaDeConversao,
  ClienteOrcamento,
  ClienteVenda,
  GEProjetos,
  LucratividadeVendasConfirmadas,
  LucratividadeVendasAprovadas,
  ComissaoVendasConfirmadas,
  ComissaoVendasAprovadas,
  MotivoPerdaSintetico,
  MotivoPerdaAnalitico,
  Recebimentos,
  ComissaoPorTime,
  PagamentosAprovados,
  ProdutosVendidos,
  Fretes,
  PedidosPorTime,
  OrcamentoSinteticoPainelInversor,
  Telemarketing,
  Integrados,
  CuponsDesconto,
  PedidosPagos,
  PedidosPendentesDePagamento,
  PedidosFaturados,
  PainelInversoIntegrados,
  OrcamentosPedidosPorColaborador,
  LucratividadeGeral,
  LucratividadeProduto,
  LucratividadePorProdutoFaturado,
  BateriaInversorIntegrados,
  LogProdutos,
  ProdutosSemPrecificacao,
  ValoresProjeto
}

export enum TipoSistema {
  GI = 0
}

export enum TipoDeLogin {
  Integrador = 0,
  Vendedor = 1
}

export enum TipoArquivo {
  Midia = 0,
  MidiaPreview = 1,
  TipoDeMidia = 2,
  ContratoProposta = 3,
  ProjetoAnexo = 4,
  OportunidadeAnexo = 5,
  PedidoAnexo = 6,
  ModeloDownload = 7,
  Fechamento = 8,
  Ocorrencia = 9,
  Integrador = 10,
  KitImagem = 11,
  Marca = 12,
  AnaliseDescontoAnexo = 13,
  FinanciadoraImagem = 14,
  Anexo = 15
}

export enum TipoLogOportunidade {
  InseriuOportunidade = 0,
  AtualizaouOportunidade = 1,
  ExcluiuOportunidade = 2,
  Ganhou = 3,
  Perdeu = 4,
  Reabriu = 5,
  AlterouEtapa = 6,
  InseriuAtividade = 7,
  AtualizaouAtividade = 8,
  ExcluiuAtividade = 9,
  ReativouAtividade = 10,
  FinalizouAtividade = 11,
  CongelouOportunidade = 12
}

export enum StatusDaEtapa {
  NaoRealizada = 0,
  EmAndamento = 1,
  Realizada = 2,
  Cancelamento = 3
}

export enum StatusDoPedido {
  Ativo = 0,
  Cancelado = 5,
  Expirado = -1
}

export enum TipoFiltroDataMonitor {
  NaEtapa = 0,
  PassouNaEtapa = 1
}

export enum TipoFiltroData {
  Pedido = 0,
  CancelamentoExpiracao = 1,
  Etapa = 2
}

export enum TipoRelatorio {
  PedidosPagos = 0,
  PedidosPendentesDePagamento = 1,
  PedidosFaturados = 2
}

export enum PerfilDoUsuario {
  Integrador,
  Vendedor,
  Administrador,
  Suporte
}

export enum EtapaDoPedido {
  AguardandoValidacao = 0,
  AguardandoConfirmacao = 1,
  PedidoConfirmado = 2,
  AguardandoIntegracao = 3,
  PedidoIntegrado = 4,
  AguardandoFaturamentoFinanciamento = 5,
  PedidoFaturadoFinanciamento = 6,
  AguardandoPagamentoFinanciamento = 7,
  AguardandoPagamentoRecursoProprio = 8,
  PagamentoAprovado = 9,
  PagamentoReprovado = 10,
  AguardandoSeparacao = 11,
  PedidoSeparado = 12,
  AguardandoNFe = 13,
  NFeEmitida = 14,
  AguardandoSeparacaoExpedicao = 15,
  AguardandoTransporte = 16,
  PedidoColetado = 17,
  PedidoEntregue = 18,
  PedidoForaPrazo = 19,
  AguardandoFaturamentoSemFinanciamento = 20,
  AguardandoConferencia = 21,
  PedidoConferido = 22,
  AguardandoVerificacao = 23,
  PedidoVerificado = 24,
  AguardandoAnaliseBanco = 25,
  AguardandoAnaliseCredito = 26,
  PedidoAprovadoBanco = 27,
  PedidoAprovadoFinanceiro = 28,
  AguardandoFaturamento = 29,
  PedidoFaturado = 30,
  AguardandoDadosTransporte = 31,
  AguardandoTriagem = 32,
  Em_Pendencia = 33,
  Resolvido = 34,
  AguardandoConferenciaTriagem = 35,
  EmImportacao = 36,
  AguardandoConferenciaPagamento = 37,
  Editando = 38
}

export enum AcaoAcompanhamento {
  Aprovar = 0,
  Reprovar = 1,
  Separar = 2,
  Despachar = 3,
  Entregar = 4,
  VincularNotaFiscal = 5,
  ConferirSeparacao = 6,
  FaturarFinanciamento = 7,
  Integrar = 8,
  FaturarSemFinanciamento = 9,
  AguardarValidacao = 10,
  AguardarIntegracao = 11,
  Conferir = 12,
  Verificar = 13,
  AprovarBanco = 14,
  AprovarFinanceiro = 15,
  Faturar = 16,
  ConferirSeparacaoTransporte = 17,
  EmPendencia = 18,
  ResolverPendencia = 19,
  AprovarTriagem = 20,
  AprovarConferenciaTriagem = 21,
  VoltarPedidoParaAguardandoTriagem = 22,
  EmImportacao = 23,
  EmSeparacao = 24,
  ConferirPagamento = 25
}

export enum StatusDoFechamento {
  EmAnalise = 0,
  Aprovado = 1,
  Reprovado = 2
}

export enum StatusDaOcorrencia {
  Novo = 0,
  EmAndamento = 1,
  Concluido = 2
}

export enum StatusDaEntregaOcorrencia {
  EmAndamento = 0,
  Entregue = 1
}

export enum TipoDeLogAcesso {
  Login = 0,
  MontarKit = 1,
  KitPronto = 2,
  Avulso = 3,
  ClonarOrcamento = 4,
  ClonarPedido = 5,
  EditarPedido = 6,
  EditarOrcamento = 7
}

export enum StatusTransportadora {
  Bloqueado = 0,
  Ativo = 1
}

export enum TipoFiltroCarteiraIntegradores {
  FezLogin = 1,
  FezOrcamento = 2,
  FezPedido = 3,
  AtividadesPendentes = 4,
  FormaDePagamento = 5,
  Classificacao = 6,
  Tags = 7,
  CondicaoDePagamento = 8,
  VendaDireta = 9,
  UF = 10,
  Cidade = 11,
  Fase = 12,
  Tensao = 13,
  TipoTelhado = 14,
  InversorMarca = 15,
  PainelMarca = 16,
  PainelPotencia = 17,
  Potencia = 18,
  Consumo = 19,
  Status = 20
}

export enum TipoCampoFiltroCarteiraIntegradores {
  titulo = 0,
  comboUnico = 1,
  comboMultiplo = 2,
  campoUnico = 3,
  campoDePara = 4
}

export enum TipoTag {
  pedido = 0,
  integrador = 1
}

export enum StatusDaAtividade {
  Pendente = 0,
  Concluida = 1,
  Cancelada = 2
}

export enum TipoCampoPersonalizado {
  SelecaoUnica = 0,
  SelecaoMultipla = 1,
  Texto = 2
}

export enum TipoAplicacao {
  Integrador = 0,
  Pedido = 1,
  Produto = 2,
  AnaliseDescontoSolicitacao = 3,
  AnaliseDescontoConclusaoPositiva = 4,
  AnaliseDescontoConclusaoNegativa = 5
}

export enum TipoValor {
  Percentual = 0,
  Valor = 1
}

export enum TipoVoucher {
  Normal = 0,
  FormaPagamento = 1
}

export enum TipoVoucherAutomatico {
  Valor = 0,
  Quantidade = 1,
  Classificacao = 2
}

export enum TipoRankingCarteira {
  Inversores = 1,
  Paineis = 2,
  Integradores = 3,
  Cidades = 4,
  UFs = 5,
  IntegradoresAcessos = 6,
  IntegradoresSimulacoes = 7,
  Vendedores = 8
}

export enum TipoEstatisticaCarteira {
  Integradores = 1,
  OrcamentosPedidos = 2,
  OsMais = 3
}

export enum TipoDeTelhado {
  Ceramica = 0,
  Fibrocimento = 1,
  Galvanizado = 2,
  Zipado = 3,
  Matalico = 4,
  Laje = 5,
  Solo = 6,
  MatalicoMini = 7,
  Fibrometal = 8,
  Colonial = 9,
  RomanaAmericana = 10,
  SemEstrutura = 11,
  Calhetao = 12,
  Carport = 13
}

export enum Orientacao {
  Retrato = 0,
  Paisagem = 1
}

export enum TipoPergunta {
  SimOuNao = 0,
  Texto = 1,
  Ambos = 2
}

export enum QtdDiasBloqueioAutomatico {
  nunca = 0,
  '30dias' = 1,
  '60dias' = 2,
  '180dias' = 3
}

export enum TipoCliente {
  Juridica = 0,
  Fisica = 1
}

export enum StatusCadastroEnum {
  Inativo = 0,
  Ativo = 1,
  Excluido = 2
}

export enum CRMAtributoMascara {
  MaskString = 0,
  MaskNumber = 1,
  MaskDate = 2
}

export enum StatusPendencia {
  Pendente = 0,
  Soluncionada = 1
}

export enum TipoOperacaoLog {
  Insercao = 0,
  Alteracao = 1
}

export enum CRMPesoAtividade {
  Negativo = -1,
  Neutro = 0,
  Positivo = 1
}

export enum CRMTipoBI {
  Orcamento = 0,
  Pedido = 1
}

export enum StatusSolicitacaoToken {
  Solicitado = 0,
  Aprovado = 1,
  Reprovado = 2,
  Cancelado = 3
}

export enum CRMStatusPedidoBI {
  Todos = 1,
  Ativo = 0,
  Expirado = 3,
  Cancelado = 5
}

export enum ModeloDeEstatistica {
  Simulacoes = 1,
  Orcamentos = 2,
  Pedidos = 3,
  PedidosNaoConfirmados = 4,
  PedidosConfirmados = 5,
  Integradores = 6,
  IntegradoresAtivos = 7,
  IntegradoresBloqueados = 8,
  AcessosVendedores = 9,
  AcessosIntegradores = 10
}

export enum TipoDeEstatistica {
  Analitico = 0,
  Quantidade = 1,
  Soma = 2,
  Media = 3
}

export enum IntervaloAbsoluto {
  Personalizado = 0,
  Hoje = 1,
  SemanaAtual = 2,
  QuinzenaAtual = 3,
  MesAtual = 4,
  TrimestreAtual = 5,
  QuadrimestreAtual = 6,
  SemestreAtual = 7,
  AnoAtual = 8,
  Ontem = 21,
  SemanaPassada = 22,
  QuinzenaPassada = 23,
  MesPassado = 24,
  TrimestrePassado = 25,
  QuadrimestrePassado = 26,
  SemestrePassado = 27,
  AnoPassado = 28,
  Amanha = 41,
  SemanaFutura = 42,
  QuinzenaFutura = 43,
  MesFuturo = 44,
  TrimestreFuturo = 45,
  QuadrimestreFuturo = 46,
  SemestreFuturo = 47,
  AnoFuturo = 48
}

export enum Momento {
  Presente = 0,
  Passado = 1,
  Futuro = 2
}

export enum TipoEnderecoEntrega {
  NaoInformado = 0,
  Integrador = 1,
  VendaDireta = 2,
  Personalizado = 3
}

export enum ICTipoFeedItem {
  Login = 0,
  Logout = 1,
  NovoOrcamento = 2,
  NovoPedido = 3,
  ConfirmouPedido = 4,
  NovoIntegrador = 5,
  NovaSimulacao = 6,
  EditouOrcamento = 7,
  EditouPedido = 8,
  PerdeuIntegrador = 9
}

export enum TipoEmbalagem {
  Pallet = 0,
  Caixa = 1,
  Cilindro = 2
}

export enum TipoCalculoPedido {
  Normal = 0,
  SimularDesconto = 1,
  SimularValorFinal = 2
}

export enum TipoFila {
  AnaliseDeDesconto = 0,
  FinSimulacao = 1,
  MonitorConferencia = 2
}

export enum StatusFila {
  Inativa = 0,
  Ativa = 1
}

export enum StatusTarefa {
  NaoIniciada = 0,
  Iniciada = 1,
  Pausada = 2,
  Retomada = 3,
  Ganha = 4,
  Perdida = 5,
  Cancelada = 6,
  NaoAtribuida = 7,
  CanceladaSistema = 8
}

export enum TipoTarefa {
  AnaliseDeDesconto = 0,
  FinSimulacao = 1,
  MonitorConferencia = 2
}

export enum AnaliseDescontoStatus {
  NaoIniciada = 0,
  Iniciada = 1,
  Pausada = 2,
  Retomada = 3,
  DescontoConcedido = 4,
  DescontoNaoConcedido = 5,
  Cancelada = 6,
  NaoAtribuida = 7
}

export enum FinSimulacaoStatus {
  Solicitada = 0,
  Disponivel = 1,
  Finalizada = 2,
  Cancelada = 3,
  Negada = 4
}

export enum FinPropostaStatus {
  Pronta = 0,
  Escolhida = 1,
  EmAnalise = 2,
  Aprovada = 3,
  Reprovada = 4,
  Cancelada = 5,
  Concluida = 6,
  ComErro = 7
}

export enum FinSimulacaoFinanciadoraStatus {
  Pendente = 0,
  Solicitando = 1,
  Disponivel = 2,
  Indisponivel = 3,

  // Novas
  Finalizado = 4,
  DadosSolicitacao = 5,
  ErroIntermitente = 20,
  ErroCritico = 29
}

export enum FinEnriDadosStatus {
  NaoIniciada = 0,
  Iniciada = 1,
  Pausada = 2,
  Retomada = 3,
  Concluída = 4,
  Cancelada = 6,
  NaoAtribuida = 7
}

export enum FinEnriDadosTipoCampo {
  Decimal = 0,
  Inteiro = 1,
  Texto = 2
}

export enum TipoArquivoAnexo {
  Imagem = 0,
  Pdf = 1,
  Outros = 2
}

export enum TipoCalculoMarkup {
  Simples = 0,
  Composto = 1
}

export enum TipoNotaOcorrencia {
  Venda = 0,
  Devolucao = 1,
  Troca = 2,
  Bonificacao = 3,
  Coleta = 4
}

export enum FilaTarefaTipoOrdenacao {
  ListaFila = 0,
  ListaOperadores = 1,
  DataSolicitacao = 2
}

export enum TipoCIF {
  SemDescarga = 0,
  ComDescarga = 1
}

export enum FormaRecebimento {
  Credito = 1,
  Debito = 2,
  Boleto = 4,
  Pix = 5,
  Manual = 6
}

export enum Rastreio {
  AguardandoPagamento = 1,
  AguardandoFaturamento = 2,
  AguardandoSeparacao = 3,
  AguardandoTransporte = 4,
  PedidoColetado = 5,
  PedidoEntregue = 6,
  Outros = 0
}

export enum FinSimulacaoOrigem {
  Integrador = 0,
  Central = 1
}

export enum OrigemFiltroPedido {
  Orcamento = 0,
  Pedido = 1,
  Repasse = 2,
  ClassificacaoPedidos = 3
}

export enum FinPropostaTipoCriacao {
  Gateway = 0,
  Manual = 1
}

export enum FinPropostaTipoFormulario {
  Gateway = 0,
  Manual = 1,
  Nenhum = 2
}

export enum TipoFormularioProposta {
  Gateway = 0,
  Manual = 1,
  Nenhum = 2
}

export enum AcaoKit {
  Substituir = 0,
  Remover = 1
}

export enum OrigemGI {
  KitCustomizado = 0,
  KitFechado = 1,
  Avulso = 2,
  LojaProdutos = 3
}

export enum TipoVendaFormaPag {
  Fixo = 0,
  Variavel = 1
}

export enum TipoVerificacaoImagem {
  SemImagem = 0,
  BuscouImagem = 1,
  RecuperarImagem = 2
}

export enum VersaoApiImposto {
  V1 = 0,
  V2 = 1
}

export enum GiFinTipoSituacao {
  Simulacao = 0,
  Financiadora = 1,
  Proposta = 2
}

export enum TipoPrecificacao {
  Desconto = 0,
  Acrescimo = 1
}

export enum TipoFiltroProduto {
  Agrupamento = 0,
  Categoria = 1
}

export enum OrdenacaoPadraoOrcPed {
  MaisRecente = 0,
  DataHora = 1
}
